import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    image_url: string = 'https://images.adcaisse.online';
  //backend_url_Pos: string =  "/v1/";
  backend_url_Pos: string =  "https://be.adcaisse.online/bp-api-pos/v1/";
  backend_url_Admin: string =  "https://be.adcaisse.online/bp-api-admin/v1/";
  backend_url_Product: string =  "https://be.adcaisse.online/bp-api-product/v1/";
  backend_url_Transaction: string =  "https://be.adcaisse.online/bp-api-transaction/v1/";
  backend_url_Analytics: string =  "https://be.adcaisse.online/bp-api-analytics/v1/";
  //backend_url_Analytics: string =  "/v1/";
  backend_url_Reservation: string =  "https://be.adcaisse.online/bp-api-reservation/v1/";
  //backend_url_loyality: string =  "/bp-api-loyality-v2/v1/";
  backend_url_loyality: string =  "https://be.adcaisse.online/bp-api-loyality-v2/v1/";
  backend_url_customer: string =  "https://be.adcaisse.online/bp-api-customer/v1/";
  backend_url_Notification: string =  "https://be.adcaisse.online/bp-api-notification/v1/";
  /** Service IA prédictions (Prophet) — chemins relatifs: predict, top-products */
  backend_url_Prediction: string = "http://167.86.79.22:8000/api/v1/prediction/";

  constructor() { }
}
